import { useState } from "react"
import { Pie } from "react-chartjs-2"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { Download } from "lucide-react"

// Register necessary Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend)

export default function DeliveryPerformance() {
  const [timeRange, setTimeRange] = useState("30")

  // Dummy data
  const success = 0
  const failure = 0
  const pending = 0

  const data = {
    labels: ['Success', 'Failure', 'Pending'],
    datasets: [
      {
        label: 'Delivery Stats',
        data: [success, failure, pending],
        backgroundColor: ['#10b981', '#ef4444', '#facc15'], // green, red, yellow
        borderWidth: 1,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}%`
          },
        },
      },
    },
  }

  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
      <div className="flex justify-between items-center p-4 border-gray-200 border-b">
        <div>
          <h3 className="font-medium">Delivery Performance</h3>
          <p className="text-gray-500 text-sm">Success rates and failures</p>
        </div>
        <div className="flex items-center space-x-2">
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="px-3 py-1 border border-gray-300 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          >
            <option value="7">Last 7 days</option>
            <option value="14">Last 14 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
          </select>
          <button className="hover:bg-gray-100 p-2 rounded-md text-gray-500 hover:text-gray-700">
            <Download className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="flex justify-center items-center mx-auto p-4 h-80">
        <div className="mx-auto w-full max-w-md h-full">
          <Pie data={data} options={options} />
        </div>
      </div>

      <div className="bg-gray-50 p-4 border-gray-200 border-t text-gray-600 text-sm text-center">
        Showing data for last <span className="font-medium">{timeRange}</span> days
      </div>
    </div>
  )
}
